import { isDefined } from '@sgme/fp';
import { connect } from 'react-redux';
import { isBasketOptimizerProcessing } from 'state/advisory/basket-optimizer/selectors';
import { isBackTestRunning } from 'state/backTest/backTest.selector';
import { isFeedbackSubmissionRunning } from 'state/missed-deal-feeedback/selectors';
import { getFormInfos, getFormQuoteId, isFormInputData, isPendingEnrichment } from 'state/selectors';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import { dynamicWorkspaceRepriceQuoteThunk } from 'state/workspaces/dynamic/dynamic.thunks';
import type { QuoteWorkspaceType } from 'state/workspaces/model';
import { staticWorkspaceRepriceQuoteThunk } from 'state/workspaces/static/static.thunks';

interface OwnProps {
  tabId: string;
  workspaceType: QuoteWorkspaceType;
}

interface StateProps {
  isFormDirty: boolean;
  isHidden: boolean;
  repriceType: string;
}

interface DispatchProps {
  onReprice(): void;
}

export type RepriceQuoteButtonProps = OwnProps & StateProps & DispatchProps;

function mapStateToProps(state: AppState, { tabId, workspaceType }: OwnProps): StateProps {
  const quoteId = getFormQuoteId(state, workspaceType, tabId)!;
  const quoteType = state.quotes.infos[quoteId]?.quoteType;
  const { actions } = getFormInfos(state, workspaceType, tabId)!;
  const isDisabled = isDefined(quoteType)
    ? (actions.find(action => action.name.includes(quoteType))?.isDisabled ?? false)
    : true;
  const isFormDirty =
    isPendingEnrichment(state, tabId) ||
    isFormInputData(state, tabId) ||
    isBackTestRunning(state, tabId) ||
    isFeedbackSubmissionRunning(state, tabId) ||
    isBasketOptimizerProcessing(state, tabId);
  return { isFormDirty, isHidden: isDisabled ?? false, repriceType: quoteType! };
}

function mapDispatchToProps(dispatch: ThunkDispatch, { tabId, workspaceType }: OwnProps): DispatchProps {
  return {
    onReprice() {
      if (workspaceType === 'static') {
        dispatch(staticWorkspaceRepriceQuoteThunk(tabId));
      } else {
        dispatch(dynamicWorkspaceRepriceQuoteThunk(tabId));
      }
    },
  };
}

export const connectRepriceQuoteButton = connect(mapStateToProps, mapDispatchToProps);
